<template>
  <q-form
      class="col q-gutter-md"
      @submit="$emit('onSubmit')"
      autofocus
      >
      <div class="row q-gutter-md">
        <q-input
            class="col-10 col-sm-3"
            label="Name *"
            :rules="[val => !!val || 'Der Name darf nicht leer sein.']"
            :model-value="mission.title"
            @update:model-value="updateField('title', $event)"
            />
    <q-input
        class="col-10 col-sm-3"
        label="Kurzbeschreibung"
        :model-value="mission.excerpt"
        @update:model-value="updateField('excerpt', $event)"
        />
      <div class="col-10 col-sm-6">
        <div class="text-h6 q-mb-sm">Infos</div>
        <q-editor
            filled
            placeholder="Füge hier den Infotext ein..."
            type="textarea"
            label="Beschreibung *"
            :model-value="mission.description"
            @update:model-value="updateField('description', $event)"
            />
      </div>
      <div class="col-10 col-sm-3">
        <div class="text-h6">Datum</div>
        <q-date
            mask="YYYY-MM-DD"
            v-model="date"
            @update:model-value="(val) => $emit('update:date', val)"
            class="full-width"
            minimal
            flat
            bordered
            range
            />
          <div class="text-caption text-grey q-mt-xs">
            Ein Tag: Datum anklicken &nbsp;|&nbsp; Zeitraum: zweiten Tag anklicken
          </div>
      </div>
      <slot></slot>
      <div class="col-12">
        <q-btn
            color="primary"
            :label="buttonLabel"
            icon="event"
            type="submit"
            />
      </div>
    </div>
  </q-form>
</template>

<script setup>
  import { ref, onMounted } from 'vue'

  const mission = defineModel('mission', { type: Object, required: true })
  defineProps({
      buttonLabel: String
    })
  defineEmits(['update:date', 'onSubmit'])
  const date = ref('')

  onMounted(() => {
    updateDatePicker()
  })

  function updateField(key, value) {
    mission.value = { ...mission.value, [key]: value }
  }

  function updateDatePicker() {
    if(mission.value.start_date != "" && mission.value.end_date != "") {
      if(mission.value.start_date == mission.value.end_date) {
        date.value = mission.value.start_date
      }
      else {
        date.value = {
          from: mission.value.start_date,
          to: mission.value.end_date
        }
      }
    }
    else {
      date.value = new Date().toISOString().slice(0, 10)
    }
  }

</script>
